import defaults from './config';
import { array_get } from './helpers/array_access';
import StoreLocator from './components/store-locator.vue';

/**
 * StoreLocatorPlugin.
 * @type {Object}
 * @example
 * Vue.use(StoreLocator, {
 *     // see config.js for all options...
 *     formatCard() {},
 *     formatInfoWindow() {},
 *     formatStores() {},
 * });
 */
const StoreLocatorPlugin = {
  install(Vue, options) {
    Vue.prototype.config = {
      formatCard: null,
      formatInfoWindow: null,
      formatMarker: null,
      formatStore: null,
      installComponents: true,
      ...defaults,
      ...options,
    };

    // @note - Event `bus` is used to dispatch actions between components
    Vue.prototype.$bus = new Vue();
    Object.defineProperties(Vue.prototype.$bus, {
      on: {
        get() {
          return this.$on;
        },
      },
      once: {
        get() {
          return this.$once;
        },
      },
      off: {
        get() {
          return this.$off;
        },
      },
      emit: {
        get() {
          return this.$emit;
        },
      },
    });

    // @see https://github.com/BosNaufal/vue-simple-store/blob/master/vue-simple-store.js
    Vue.prototype.$action = {
      dispatch(name, ...args) {
        return new Promise((resolve, reject) => {
          if (typeof this[name] !== 'undefined') {
            resolve(this[name](...args));
          }

          reject();
        });
      },

      register(name, callback) {
        this[name] = callback;
      },
    };

    /**
     * @param key
     * @param defaultValue
     * @return {mixed}
     */
    Vue.prototype.getConfig = function (key = null, defaultValue = null) {
      if (key === null) {
        return Vue.prototype.config;
      }

      return array_get(Vue.prototype.config, key, defaultValue);
    };

    // Vue.prototype.createComponent = Vue.component;

    /**
     * Display logging message only if debug == true.
     */
    Vue.prototype.trace = function () {
      if (Vue.prototype.config.debug) {
        console.log(
          '[StoreLocator]',
          ...Array.prototype.slice.apply(arguments)
        );
      }
    };

    // @note - Card template
    Vue.component('cp-card', {
      props: {
        store: {
          type: Object,
        },
      },
      template: Vue.prototype.config.formatCard
        ? Vue.prototype.config.formatCard()
        : Vue.prototype.config.templates.card,
    });

    if (Vue.prototype.config.installComponents) {
      Vue.component('cp-store-locator', StoreLocator);
    }
  },
};

if (window.Vue) {
  window.Vue.use(StoreLocatorPlugin);
}

export default StoreLocatorPlugin;
